import React, { useEffect } from "react";
import { ApiCustomer } from "src/api/api_customer";
import { FullTag } from "src/api/generated/frontend_customer_v1";
import { UUID } from "src/api/api_common";

/** Data provided by the {@link SINGLE_TAG_CONTEXT} */
export type SingleTagContext = {
    /** The currently available tag */
    tag: FullTag;

    /** Reload the tags' information */
    reset: () => void;
};

/** {@link React.Context} to access the tags */
const SINGLE_TAG_CONTEXT = React.createContext<SingleTagContext>({
    tag: {
        name: "",
        uuid: "",
        description: "",
        devices: [],
        inbound_access_rules: [],
        outbound_access_rules: [],
        locked: false,
    },

    /**
     * Reset the tags
     */
    reset: () => {},
});
SINGLE_TAG_CONTEXT.displayName = "SingleTagContext";
export default SINGLE_TAG_CONTEXT;

/**
 * The properties for {@link SingleTagProvider}
 */
export type SingleTagProviderProps = {
    /** Identifier for the tag */
    uuid: UUID;

    /**
     * Children of the provider
     */
    children: React.ReactNode;
};

/**
 * The provider of a tag context
 */
export function SingleTagProvider(props: SingleTagProviderProps) {
    const [tag, setTag] = React.useState<FullTag | "loading">("loading");
    let fetching = false;

    /**
     * Fetch the tags
     */
    const fetchTag = async () => {
        if (fetching) return;
        fetching = true;

        const res = await ApiCustomer.tags.getSingle(props.uuid);
        setTag(res);

        fetching = false;
    };

    useEffect(() => {
        fetchTag().then();
    }, [props.uuid]);

    if (tag === "loading") {
        return <div>Loading ..</div>;
    }

    return (
        <SINGLE_TAG_CONTEXT.Provider
            value={{
                tag,
                reset: fetchTag,
            }}
        >
            {props.children}
        </SINGLE_TAG_CONTEXT.Provider>
    );
}
